import React, { memo, useMemo, useRef } from 'react';
import { Button } from '@mui/material';
import { useOpen } from 'AurionCR/components/hooks';
import { PrescriptionDetailsPopup } from 'components/medical-prescription';
import { apiUserPatientPrescriptions } from 'services/user-patient-profile-prescriptions';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useEffectError } from 'hooks';

interface Props {
  drugs: string[];
  id: string;
}
export const TemplatePrescriptionDrugs = memo<Props>(({ drugs, id }) => {
  const { isOpen, handleClose, handleToggle } = useOpen();

  const ref = useRef(null);
  const title = useMemo(() => {
    return drugs.filter(Boolean).join(' | ');
  }, [drugs]);

  const skip = !isOpen;

  const {
    data: prescription,
    isLoading,
    error,
  } = apiUserPatientPrescriptions.useGetMedicalPrescriptionWithDetailsQuery(id, {
    skip,
  });
  useEffectError(error);

  return (
    <>
      <Button
        fullWidth
        ref={ref}
        onClick={handleToggle}
        endIcon={<VisibilityIcon color={'primary'} />}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
        disabled={!drugs.length}
      >
        {title}
      </Button>
      <PrescriptionDetailsPopup
        isLoading={isLoading}
        count={drugs.length}
        userPatientProfilePrescriptionID={id}
        rows={prescription ? prescription.details : []}
        open={isOpen}
        anchorEl={ref.current}
        onClose={handleClose}
      />
    </>
  );
});
